<template>
  <b-dropdown
    ref="dropdown"
    :class="submenuClass"
    :toggle-class="computedToggleClass"
    variant="none"
    left
    :no-caret="noCaret"
    :dropright="dropright"
    :menu-class="`${menuClass} max-h-[300px] overflow-y-auto`"
    @show="onShow"
    @hide="onHide"
  >
    <template #button-content>
      <slot name="toggle">
        <span
          v-if="label"
          class="hover-salmon text-6 w-100"
        >{{ label }}</span>
      </slot>
    </template>
    <slot />
  </b-dropdown>
</template>

<script>
export default {
  name: 'NestedDropdownSubmenu',
  inject: {
    nestedDropdown: { default: null },
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    submenuClass: {
      type: String,
      default: 'w-100',
    },
    toggleClass: {
      type: String,
      default: 'text-left',
    },
    onShowClass: {
      type: String,
      default: '!bg-[#FCD4BE]',
    },
    menuClass: {
      type: String,
      default: '',
    },
    noCaret: {
      type: Boolean,
      default: true,
    },
    dropright: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowing: false,
    }
  },
  computed: {
    computedToggleClass() {
      if (this.isShowing) {
        return `${this.toggleClass} ${this.onShowClass}`
      }
      return this.toggleClass
    },
  },
  mounted() {
    if (this.nestedDropdown) {
      this.nestedDropdown.registerSubmenu(this)
    }
  },
  beforeDestroy() {
    if (this.nestedDropdown) {
      this.nestedDropdown.unregisterSubmenu(this)
    }
  },
  methods: {
    /** Tutup submenu ini */
    close() {
      const { dropdown } = this.$refs
      if (dropdown && dropdown.visible) {
        dropdown.hide()
      }
    },
    onShow() {
      if (this.nestedDropdown) {
        this.nestedDropdown.setActiveSubmenu(this)
      }
      this.isShowing = true
    },
    onHide() {
      this.isShowing = false
      if (this.nestedDropdown) {
        this.nestedDropdown.onSubmenuHide(this)
      }
    },
  },
}
</script>
